export enum Response {
  Yes,
  No
}
